import {ChangeDetectionStrategy, Component, input, InputSignal} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GameModel} from 'shared/models';
import {GameUi} from '../game-ui/game-ui';

@Component({
  selector: 'games-ui',
  standalone: true,
  imports: [CommonModule, GameUi],
  templateUrl: './games-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GamesUi {
  games: InputSignal<GameModel[]> = input.required<GameModel[]>();
}
